// Generated from contracts/runtime/resourceAccess.ts; do not edit.
/** Canonical protected-resource failure policy for independent Web/Mobile clients. */
export function isResourceAccessDenied(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const value = error as {status?: unknown; statusCode?: unknown; response?: {status?: unknown}};
  return [401, 403, 404].includes(Number(value.status ?? value.statusCode ?? value.response?.status));
}
